// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3I0YE","rightAdornment":"Header_rightAdornment__xM44X"};